export const optionsPriority = [
    { label: 'BAIXA', value: 0 },
    { label: 'MÉDIO', value: 1 },
    { label: 'ALTA', value: 2 },
    { label: 'URGENTE', value: 3 },
]

export const priorityMap = {
    BAIXA: { value: 'green', label: 'Baixa' },
    MEDIA: { value: 'yellow', label: 'Média' },
    ALTA: { value: 'red', label: 'Alta' },
    URGENTE: { value: 'red', label: 'Urgente' },
};

export const statusMap = {
    ESCALADO: { value: 'execucao', label: 'Escalado' },
    RESOLVIDO: { value: 'resolvido', label: 'Resolvido' },
    EXECUCAO: { value: 'execucao', label: 'Em Execução' },
    ABERTO: { value: 'aberto', label: 'Pendente' },
    CANCELADO: { value: 'cancelado', label: 'Cancelado' },
};

export const ratingOption = [
    { label: 'Ruim', value: 0 },
    { label: 'Regular', value: 1 },
    { label: 'Bom', value: 2 },
    { label: 'Excelente', value: 3 },
]

export const intervaloDatas = [
    { value: 7, label: 'Mês atual' },
    { value: 30, label: 'Mês Anterior' },
    { value: 365, label: "Ano Atual" },
    { value: 14, label: "Personalizado" },
]

export const intervaloDatasFull = [
    { value: 7, label: 'Mês atual' },
    { value: 30, label: 'Mês Anterior' },
    { value: 0, label: 'Hoje' },
    { value: 1, label: 'Ontem' },
    { value: 2, label: 'Anteontem' },
    { value: 90, label: 'Últimos 90 dias' },
    { value: 365, label: "Últimos 365 dias" },
    { value: 14, label: "Personalizado" }
]

export const retornaTipoDaRota = (item) => {
    if (item === "AS") return "AS+";
    if (item === "DOIS_DIAS") return "48 Horas";
    if (item === "DIARIA") return "24 Horas";
    if (item === "TRES_DIAS") return "72 Horas";
    if (item === "REPROGRAMACAO") return "Reprogramação";
    if (item === "FRETE") return "Frete";
}

export const MESES = [
    { label: "Janeiro", value: 1 }, { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 }, { label: "Abril", value: 4 },
    { label: "Maio", value: 5 }, { label: "Junho", value: 6 },
    { label: "Julho", value: 7 }, { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 }, { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 }, { label: "Dezembro", value: 12 },
];

export const ANOS = [{ label: "2026", value: 2026 }, { label: "2027", value: 2027 }];
